import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { defaultTheme } from 'lib/themes';
import { format } from 'phone-fns';
import { withStyles } from '@mui/styles';
import { compose } from 'recompose';
import { styles } from './final-page/final-page.styles';
import Container from '../components/container';
import WidthController from '../components/width-controller';

const PostSubmissionErrorPage = ({ store, classes }) => {
  const {
    pharmacyInfo: { pharmacyPhoneNumber, openTime, closeTime },
  } = store;

  return (
    <Container
      title="It's time for your refill"
      footer={<Box height={55} backgroundColor={defaultTheme.palette.primary.teal} />}
    >
      <WidthController className={classes.container}>
        <Stack direction="column" spacing={5} data-qa-id="final-page">
          <Typography
            className={classes.message}
            color={defaultTheme.palette.primary.teal}
            type="title"
            data-qa-id="title"
          >
            Ooops! There was a problem processing your order.
          </Typography>
          <Typography className={classes.message2} data-qa-id="sub-title">
            Please call us at{' '}
            <b style={{ textWrap: 'nowrap' }}>{format('NNN-NNN-NNNN', pharmacyPhoneNumber)}</b>.
            <br />
            {openTime && closeTime ? `Our hours are ${openTime} to ${closeTime}.` : null}
          </Typography>
        </Stack>
      </WidthController>
    </Container>
  );
};

export default compose(withStyles(styles))(PostSubmissionErrorPage);
